import { createRouter, createWebHistory } from "vue-router";

import Login from "@/views/login.vue";
import Main from "@/layout/MainContent.vue";

import DeviceList from "@/views/devices/device-list.vue";
import Supplier from "@/views/devices/supplier.vue";
import DeviceModel from "@/views/devices/device-model.vue";
import RemoteControl from "@/views/devices/device-operater.vue";


import User from "@/views/uc/user.vue";
import Permisson from "@/views/uc/permission.vue";
import Role from "@/views/uc/role.vue";
import Dictionary from "@/views/sys/dict.vue";
import DictionaryType from "@/views/sys/dict-type.vue";
import Org from "@/views/sys/org.vue";

import NotFound from "@/views/error/404.vue";


import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' //样式必须引入
import {getUserInf} from "@/shard/login-info-manager";


const routerMap = {
  "deviceList":{
    path: "deviceList",
    components: { mainFrame: DeviceList }
  },
  "remoteControl":{
    path: "remoteControl",
    components: { mainFrame: RemoteControl }
  },
  "supplier":{
    path: "supplier",
    components: { mainFrame: Supplier }
  },
  "devmodel":{
    path: "devmodel",
    components: { mainFrame: DeviceModel }
  },
  "user":{
    path: "user",
    components: { mainFrame: User }
  },
  "permission":{
    path: "permission",
    components: { mainFrame: Permisson }
  },
  "role":{
    path: "role",
    components: { mainFrame: Role }
  }, 
  "dictionary":{
    path: "dictionary",
    components: { mainFrame: Dictionary }
  }, 
  "dictionaryType":{
    path: "dictionaryType",
    components: { mainFrame: DictionaryType }
  }, 
  "org":{
    path: "org",
    components: { mainFrame: Org }
  },
  "/main/org":{
    path: "/main/org",
    components: { mainFrame: Org }
  }
}


const routes = [
  {
    path: "/main",
    name:"Main",
    component: Main,
    meta: { requiresAuth: true }, // 确保登录页不需要认证
    children: Object.values(routerMap)
  },
  {
    path: "/",
    redirect: '/login'
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false } // 确保登录页不需要认证
  },
  {
    path: "/:pathMatch(.*)",
    name: "NotFound",
    component: NotFound,
    meta: { requiresAuth: false } 
  }
];


const router = createRouter({
  //vue.config.js 中的 publicPath值
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => { 
  NProgress.start();
  if(to.meta.requiresAuth){
      let token = getUserInf().authToken;
      if (token == null) {
        next({ path: "/login" });
      } else {
        next();
      }
  }else{
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});

export { router,routerMap };
